import React from "react";
import { TableSection } from "../TableSection/TableSection";
import {RowOptions } from "../TableSection/TableSection";
import SectionsLogo from "../../Photos/sections-logo.svg";
import { SectionProps } from "../../App";

interface LabProps {}

function shouldRelease(assignment: RowOptions): boolean {
    if (assignment.autoReleaseDate === undefined) {
      return true; // If no defined release date, treat it as released if it has an href
    }
  
    const now = new Date();
  
    // Convert now into EST, if it isn't already
    const nowEST = new Date(
      now.toLocaleString("en-US", {
        timeZone: "America/New_York",
      })
    );
  
    return nowEST > new Date(assignment.autoReleaseDate);
}

export class Labs extends React.Component<SectionProps> {
    
    myHeader: string[] = [
        "Date",
        "Lab/Section",
        "Handout",
        "Resources",
        "Slides",
    ];

    myRows: RowOptions[] = [
        { cellNames: ["9/9-9/11", "Lab 0: Linux & Terminal", "Handout", "Setup Guide", "-"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/AHHwP1fASlGKHo9ugO9fIw?view"],
                ["Setup Guide", "https://docs.google.com/presentation/d/1NXNeXh6DH-MNqmpYfd2yfaPeRouofMMOPYcoadNQfm8/edit?slide=id.p#slide=id.p"]
            ]),
            autoReleaseDate: "Sep 9, 2025 10:10:00 EDT",
        },
        { cellNames: ["9/16-9/18", "Lab 1: Intro to Java", "Handout", "-", "-"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/9AuLYpvoV"],
            ]),
            autoReleaseDate: "Sep 16, 2025 10:10:00 EDT",
        },
        { cellNames: ["9/23-9/25", "Section 2: Class Relationships", "-", "-", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Slides", "https://docs.google.com/presentation/d/1Y0moIFyaXzDsv9_eQl4Qs6ojXb62griwDwgWZ4dGXKo/edit?usp=sharing"]
            ]),
            autoReleaseDate: "Sep 23, 2025 10:10:00 EDT",
        },
        { cellNames: ["9/30-10/2", "Section 3: Polymorphism", "Handout", "-", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/SsnsdMVrA"],
                ["Slides", "https://docs.google.com/presentation/d/1xyzi2GvhPZeQpqFJxvUS4_OOCBaStMFvBrA36DLSBpw/edit?usp=sharing"]
            ]),          
            autoReleaseDate: "Sep 30, 2025 10:10:00 EDT",

        },
        { cellNames: ["10/7-10/9", "Lab 4: JavaFX", "Handout", "Video", "-"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/LNy0-q8W-"],
                ["Video", "https://www.youtube.com/watch?v=bM2u5OUF1YQ"]
            ]),
            autoReleaseDate: "Oct 7, 2025 10:10:00 EDT",
        },
        { cellNames: ["10/14-10/16", "Lab 5: Debugging", "Handout", "-", "-"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/zftbmzO8o"],
            ]),
            autoReleaseDate: "Oct 14, 2025 10:10:00 EDT",
        },
        { cellNames: ["10/21-10/23", "Section 6: 1D Array, ArrayLists, and Loops", "Handout", "-", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/BLDUVcXGL"],
                ["Slides", "https://docs.google.com/presentation/d/12H_IX8IMigmJt3VxOqokzUY-FGwT-HKR7G-O7gkqnsk/edit?usp=sharing"]
            ]),
            autoReleaseDate: "Oct 21, 2025 10:10:00 EDT",
        },
        { cellNames: ["10/28-10/30", "Lab 7: 2D Arrays", "Handout", "Video", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/Hsvdty8Ix"],
                ["Video", "https://drive.google.com/file/d/1Jci5TA_4o2pZLjB5C87is2SCqtq93Hv5/view?usp=sharing"],
                ["Slides", "https://docs.google.com/presentation/d/1Tu0iOMt35vEMLooFViqRl02T4KfIzLW9mtUHpa4iVXc/edit?usp=sharing"]
            ]),
            autoReleaseDate: "Oct 28, 2025 10:10:00 EDT",
        },
        { cellNames: ["11/4-11/6", "Section 8: Algorithms", "-", "-", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Slides", "https://docs.google.com/presentation/d/1XKVxT_6qI7WQVkG8xMNd_olvnkpv64iXzdoRMM5PLzg/edit?usp=sharing"]
            ]),
            autoReleaseDate: "Nov 4, 2025 09:00:00 EST",
        },
        { cellNames: ["11/11-11/13", "Lab 9: Data Structures and Recursion", "Handout", "-", "Slides"], 
            cellNametoLinks: new Map<string,string>([
                ["Handout", "https://cs15-hedgedoc-production.up.railway.app/s/W_4o3WlUd"],
                ["Slides", "https://docs.google.com/presentation/d/1hw8DotKq-JTsjDugk4JZOnAsn-rXqcPAszdDLJjNhVg/edit?usp=sharing"]
            ]),
            autoReleaseDate: "Nov 11, 2025 10:10:00 EST",
        },
    ];

    render() {
        const modifiedRows: RowOptions[] = this.myRows.map(row => {
            if (!shouldRelease(row)) {
                const updatedLinks = new Map<string, string>();

                // Iterate over the original links and replace or remove them if necessary
                row.cellNametoLinks.forEach((value, key) => {
                    updatedLinks.set(key, "");
                });

                return {
                    ...row,
                    cellNametoLinks: updatedLinks,
                    backgroundColor: "#FCD002aF"
                };
            }
            return row;
        });

        return (
            <section id = 'sections' className={`anchor sections ${this.props.static ? 'static' : ''}`}>

                <div className="content-container">
                    <img  className="sections-logo" src={SectionsLogo} alt="sections text" />
                    <TableSection header={this.myHeader} rows={modifiedRows} 
                    blurb= {`Lab/section is a time to review course content in a smaller group setting and practice applying those concepts through partnered labs. Each section will meet once a week and will be led by two TAs with around 18 students, so it is also a time to work closely with and get to know some of your fellow CS15-ers.
                            A typical lab/section consists of short group check in, a fun SRC activity, and then either a presentation and some smaller group activities to review concepts or a lab.`} />
                </div>
            </section>

        );
    }
}
